<script setup>
import BannerComponents from "@/components/system/BannerComponents.vue";
import UserComponents from "@/components/system/UserComponents.vue";
import ProductLst from "@/components/system/ProductLst.vue";
import CopyRightComponents from "@/components/system/CopyRightComponents.vue";
import LoginComponents from "@/components/login/LoginComponents.vue";
import {computed, onMounted, ref} from "vue";
import axiosApi, {$_ajax} from "@/utils/axiosApi";
import {Base64} from "js-base64";
import store from "@/store";
import {useRoute} from "vue-router";
import ProductInfoComponents from "@/components/system/ProductInfoComponents.vue";
import router from "@/router";
import {siteConfig} from "@/utils/config";
import ShuangkeDetailsComponets from "@/components/shuangke/ShuangkeDetailsComponets.vue";
import XmLogin from "@/components/login/xmLogin.vue";
import FdProductComponent from "@/components/fandeng/FdProductComponent.vue";

const searchAccount = ref("")
const route = useRoute()
const login = ref(false)
const selectProduct = ref({})
const account = computed(() => store.state.account)
const showProduct = ref(false)
const success = ref(false)
const successImg = require("@/assets/images/shuyi/success.png")
const couponType = computed(() => {
  const types = store.state.coupon
  document.title = siteConfig[types]?.title
  return types
})
const loginCall = () => {
  login.value = false
  if (Object.keys(selectProduct.value).length && Object.keys(account.value).length) showProduct.value = true
}
const setLogin = ({mobile}) => {
  searchAccount.value = mobile
  showProduct.value = false
  success.value = false
  login.value = true
}

const productCall = ({type, product}) => {
  // selectLogin.
  selectProduct.value = product
  if (type === "login") login.value = true
  else showProduct.value = true
}

onMounted(() => {
  if (route.query.customerId) {
    //处理单点登录
    $_ajax.get(`${process.env.VUE_APP_ONE_WAY}scal/check`, {params: route.query}).then(({data}) => {
      if (Object.keys(data.data).length) {
        data.data.phoneNumber = /^1[2-9]\d{9}/.test(data.data.phoneNumber) ? data.data.phoneNumber : Base64.decode(data.data.phoneNumber)
        store.dispatch("setAccounts", data.data)
      }
    })
  }
  if (route.query.from) {
    store.commit("setOrderFrom", route.query.from)
  }
  if (route.query.plate) {
    window.sessionStorage.setItem("plate", route.query.plate);
  }
  if (route.query.coupon) {
    store.commit("setCoupon", route.query.coupon)
  }
  store.dispatch("getAccounts")

  if (route.query.order) {
    new axiosApi({
      encode: "site",
      method: "xiamen/metro_order_query",
      body: {
        orderNo: route.query.order
      }
    }).send(res => {
      if (res.message.code === "000") {
        success.value = true
        // orderFlag.value = true
        // orderDat.value = res.data
      } else success.value = false
    }, () => success.value = false)
  }
})
</script>

<template>
  <el-scrollbar class="page-home page-pid" :class="couponType" :style="siteConfig[couponType]?.style?.home">
    <banner-components/>
    <user-components @query="setLogin"/>
    <product-lst @login="productCall" @pay="productCall" :showProduct="showProduct" :showOrder="success"/>
    <copy-right-components/>
  </el-scrollbar>
  <xm-login v-if="login && siteConfig[couponType]?.login === 'xm_air'" :account="searchAccount" :show-login="login" @login="loginCall"/>
  <login-components v-else-if="login" :account="searchAccount" :show-login="login" @login="loginCall"/>
  <div v-if="couponType !== 'douyin'">
    <product-info-components :show="showProduct" :product="selectProduct" @closed="showProduct=false"
                             v-if="showProduct && !/^(shuangke|fandeng).*$/.test(couponType)"
                             @success="showProduct=false,success=true"/>
    <shuangke-details-componets :show="showProduct" :product="selectProduct" @closed="showProduct=false"
                                v-if="showProduct && /^shuangke.*$/.test(couponType)"
                                @success="showProduct=false,success=true"/>
    <fd-product-component :show="showProduct" :product="selectProduct" @closed="showProduct=false"
                          v-if="showProduct && /^fandeng.*$/.test(couponType)"
                          @success="showProduct=false,success=true"/>
    <el-dialog class="login-dialog" v-model="success" center width="95%" :show-close="false">
      <div class="success">
        <div class="success-image">
          <el-image :src="successImg"/>
        </div>
        <h2 class="success-title">兑换成功</h2>
        <div class="success-btn">
          <el-button type="info" class="refund" size="large" @click="success=false">
            返回首页
          </el-button>
          <el-button type="danger" :class="`${couponType}-details`" size="large" @click="router.push({name:'order'})">
            查看订单
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
.page-home {
  height: 100vh;
  background-color: var(--theme-background);
}

.success {
  text-align: center;

  .success-title {
    color: #FF8A13;
    margin-bottom: 15px;
  }

  .el-image {
    width: 120px;
    margin-bottom: 15px;
  }

  .coupon-name {
    background: #FFCEC9;
    border-radius: 45px;
    line-height: 40px;
    width: 55%;
    margin: auto;
    color: #E31D1A;
    font-weight: 600;
    font-size: 1.23rem;
  }

  .success-btn {
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .el-button {
      border: none;
      height: 45px;
      width: 45%;
    }

    .shuyi-details {
      background: linear-gradient(180deg, #a5d63f 0%, #d0ee1a 100%);
    }

    .luckin-details {
      background: linear-gradient(180deg, rgba(49, 78, 170, 1) 0%, rgba(38, 168, 255, 1) 100%);
    }
  }

}
</style>
